export default __webpack_public_path__ + "static/media/home-work.06f6e2e5.svg";